module.exports = __webpack_public_path__ + "img/gold.81958a09.png";